import { action, makeObservable, observable } from "mobx";

export class ViewStore {
  @observable public isDocumentSidebarHidden = false;

  constructor() {
    makeObservable(this);
  }

  @action.bound
  public hideDocumentSidebar() {
    this.isDocumentSidebarHidden = true;
  }

  @action.bound
  public showDocumentSidebar() {
    this.isDocumentSidebarHidden = false;
  }
}
